import paymentTypes from '../../config/paymentTypes';

export const CREDIT_CARD = {
  ...paymentTypes.CREDIT_CARD,
};

export const ECHECK = {
  ...paymentTypes.ECHECK,
};

export const CHECK = {
  ...paymentTypes.CHECK,
};

export const CASH = {
  ...paymentTypes.CASH,
};

export const PINPAD = {
  ...paymentTypes.PINPAD,
};

export const ALIPAY = {
  ...paymentTypes.ALIPAY,
  icon: 'ic-alipay alipay color-free',
};

export const WECHAT = {
  ...paymentTypes.WECHAT,
  icon: 'ic-wechat-pay wechat color-free',
};

export const APPLEPAY = {
  ...paymentTypes.APPLEPAY,
  icon: 'apple-pay-icon',
};

export const GOOGLEPAY = {
  ...paymentTypes.GOOGLEPAY,
  icon: 'google-pay-icon',
};

export const IDEAL = {
  ...paymentTypes.IDEAL,
  icon: 'ideal-pay-icon',
};
